import { CURRENT_USER_URL } from '../../../../config/urls';

export const CURRENT_USER_KEY = [ CURRENT_USER_URL ];
